import type { C1_FurnitureDefinition } from "../types/C1_FurnitureTypes";
import { c1_state } from "../model/C1_runtimeContext";
import Armchair from "./components/C1_Armchair";
import Bathtub from "./components/C1_Bathtub";
import Desk from "./components/C1_Desk";
import DiningTable6 from "./components/C1_DiningTable6";
import DoubleBed from "./components/C1_DoubleBed";
import KitchenBlock from "./components/C1_KitchenBlock";
import KitchenBaseCabinet from "./components/C1_KitchenBaseCabinet";
import KitchenWallCabinet from "./components/C1_KitchenWallCabinet";
import Plant from "./components/C1_Plant";
import Refrigerator from "./components/C1_Refrigerator";
import Oven from "./components/C1_Oven";
import Dishwasher from "./components/C1_Dishwasher";
import ExtractorHood from "./components/C1_ExtractorHood";
import Stove from "./components/C1_Stove";
import Sink from "./components/C1_Sink";
import Shower from "./components/C1_Shower";
import SingleBed from "./components/C1_SingleBed";
import Sofa from "./components/C1_Sofa";
import Television from "./components/C1_Television";
import Toilet from "./components/C1_Toilet";
import Wardrobe from "./components/C1_Wardrobe";
import { LivingCabinet, Sideboard, Bookshelf, CoffeeTable, FloorLamp } from "./components/C1_LivingFurniture";
import Washbasin from "./components/C1_Washbasin";
import WashingMachine from "./components/C1_WashingMachine";
import WallRadiator from "./components/C1_WallRadiator";
import { HeatingSystem, HotWaterTank } from "./components/C1_HeatingEquipment";
import { Ventilation, AirConditioningIndoor, AirConditioningOutdoor } from "./components/C1_ClimateEquipment";
import { ElectricalCabinet, NetworkCabinet, OutdoorHeatPump, Wallbox } from "./components/C1_TechnicalEquipment";
import { LShapedStair, StraightStair, UShapedStair } from "./components/C1_Stairs";
import { furnitureResolvers } from "./C1_furnitureResolvers";
import LightGroup, { OutdoorLightGroup } from "./components/C1_LightGroup";
import {
  ElectricalButton, ElectricalCamera, ElectricalLight, ElectricalOutlet, FixedConsumer, FixedConsumer400,
  OutdoorButton, OutdoorLight, OutdoorOutletGroup,
  ElectricalWindowContact, ElectricalSensor, ElectricalMotionSensor, ElectricalSmokeSensor, ElectricalDoorStation, ElectricalJalousie, ElectricalBlind, ElectricalDistribution,
} from "./components/C1_ElectricalFurniture";
import { FurnitureCategory } from "../types/C1_ModelTypes";
import { isElectricalFurnitureId } from "./C1_electricalFurniture";
import { setC1EloDefinitionIconResolver } from "./C1_EloDefinitionIcons";

export function isPureElectricalFurnitureDefinition(definition: C1_FurnitureDefinition): boolean {
  return definition.category === FurnitureCategory.Electrical;
}

/** Möbel, die im Elektromodus als eigenständige Elektromöbel behandelt werden. */
export function isElectricalFurnitureDefinition(definition: C1_FurnitureDefinition | undefined): boolean {
  return Boolean(
    definition &&
      (definition.category === FurnitureCategory.Electrical ||
        definition.additionalCategories?.includes(FurnitureCategory.Electrical) ||
        isElectricalFurnitureId(definition.id)),
  );
}

export const furnitureRegistry: C1_FurnitureDefinition[] = [
  SingleBed,
  DoubleBed,
  Sofa,
  Armchair,
  LivingCabinet,
  Sideboard,
  Bookshelf,
  CoffeeTable,
  FloorLamp,
  DiningTable6,
  Desk,
  Wardrobe,
  Toilet,
  Washbasin,
  Bathtub,
  Shower,
  WallRadiator,
  KitchenBlock,
  KitchenBaseCabinet,
  KitchenWallCabinet,
  Refrigerator,
  Oven,
  Dishwasher,
  ExtractorHood,
  Stove,
  Sink,
  WashingMachine,
  HeatingSystem,
  HotWaterTank,
  Ventilation,
  AirConditioningIndoor,
  AirConditioningOutdoor,
  OutdoorHeatPump,
  ElectricalCabinet,
  NetworkCabinet,
  Wallbox,
  Television,
  Plant,
  StraightStair,
  LShapedStair,
  UShapedStair,
  LightGroup,
  OutdoorLightGroup,
  ElectricalLight,
  ElectricalButton,
  ElectricalCamera,
  ElectricalOutlet,
  FixedConsumer,
  FixedConsumer400,
  OutdoorLight,
  OutdoorOutletGroup,
  OutdoorButton,
  ElectricalWindowContact,
  ElectricalDoorStation,
  ElectricalMotionSensor,
  ElectricalSmokeSensor,
  ElectricalSensor,
  ElectricalJalousie,
  ElectricalBlind,
  ElectricalDistribution,
];

export const furnitureById = Object.fromEntries(
  furnitureRegistry.map((definition) => [definition.id, definition]),
) as Record<string, C1_FurnitureDefinition>;

/** Resolves catalog icon IDs after the furniture registry is fully initialized. */
function resolveCatalogIcon(iconDefinitionId: string) {
  return furnitureById[iconDefinitionId]?.icon;
}

furnitureResolvers.displayName = (definitionId) => furnitureById[definitionId]?.description[c1_state.language];
furnitureResolvers.definition = (definitionId) => furnitureById[definitionId];
setC1EloDefinitionIconResolver(resolveCatalogIcon);
